const state = () => ({
    questionList: [],
    answerData: {},
    judgeResult: [],
    relatedQuestionList: [],//结果页巩固练习题目列表
    relatedAnswerData: {},//结果页巩固练习答案
    relatedJudgeResult: [],////结果页巩固练习判题结果
    continue: true,//是否继续巩固练习
});


// getters
const getters = {

};

// actions
const actions = {

};

// mutations
const mutations = {
    saveAnswerData(state, answer) {
        // console.log("answerdata", answer)
        state.answerData[answer.queId] = answer;
    },
    saveRelatedAnswerData(state, answer) {

        state.relatedAnswerData[answer.queId] = answer;
    },
    saveQuestionItem(state, queData) {
        state.questionList.push(queData);
    },
    saveQuestionList(state, list) {
        state.questionList.push(...list);
    },
    saveRelatedQuestion(state, relatedQue) {
        state.relatedQuestionList.push(relatedQue);
    },
    deleteRelatedQuestion(state) {
        state.relatedQuestionList = []
    },

    //删除作答数据
    deleteAnswerData(state) {
        state.answerData = {}
    },

    //删除巩固练习作答数据
    deleteRelatedAnswerData(state) {
        state.relatedAnswerData = {}
    },
    clear(state) {
        state.questionList = [];
        state.answerData = {};
        state.judgeResult = [];
        state.relatedQuestionList = []
        state.relatedAnswerData = {},
            state.relatedJudgeResult = [];
    },
    saveJudgeResult(state, judgeResult) {
        state.judgeResult = judgeResult;
    },
    saveRelatedJudgeResult(state, judgeResult) {
        state.relatedJudgeResult = judgeResult;
    },
    updateContineValue(state, continueVal) {
        state.continue = continueVal
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};


// WEBPACK FOOTER //
// ./src/store/modules/Practice.js